import { motion } from 'framer-motion';
import { useLanguage } from '@/i18n/LanguageContext';
import LiveStatsRibbon from '@/components/sections/LiveStatsRibbon';

export default function TrustSection() {
  const { language } = useLanguage();
  const isTurkish = language === 'tr';

  const features = [
    {
      title: isTurkish ? 'Gerçek Zamanlı AI Analizi' : 'Real-time AI Analysis',
      desc: isTurkish ? 'Yapılandırılmış AI sağlayıcısı tasarım önerileri hazırlar; gecikme değişebilir' : 'The configured AI provider drafts design suggestions; latency varies'
    },
    {
      title: isTurkish ? '3D Konsept Üretimi' : '3D Concept Generation',
      desc: isTurkish
        ? 'Gerekli servis ve yeterli kaynak verisi mevcut olduğunda ön 3D konsept; süre değişkendir'
        : 'Preliminary 3D concepts when the required service and source data are available; time varies'
    },
    {
      title: isTurkish ? 'CAD Entegrasyonu' : 'CAD Integration',
      desc: isTurkish ? 'Onshape entegrasyon iş akışı (yapılandırmaya tabi)' : 'Onshape integration workflow (subject to configuration)'
    },
  ];

  return (
    <section id="trust" className="py-32 bg-[#0A0D1A] relative" data-testid="trust-section">
      {/* Subtle grid */}
      <div className="absolute inset-0 opacity-[0.02]">
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.5)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.5)_1px,transparent_1px)] bg-[size:60px_60px]" />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative">
        
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <span className="inline-block px-3 py-1.5 border border-white/10 text-xs font-mono uppercase tracking-wider text-white/50 mb-6">
            {isTurkish ? 'Ürün Durumu — Beta' : 'Product Status — Beta'}
          </span>
          <h2 className="text-3xl lg:text-4xl font-light text-white tracking-tight">
            {isTurkish ? 'Ürün ' : 'Product '}
            <span className="font-bold">{isTurkish ? 'Durumu' : 'Status'}</span>
          </h2>
        </motion.div>

        {/* Metrics Grid — live data from /api/platform/stats */}
        <LiveStatsRibbon />

        {/* Features Row */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="grid md:grid-cols-3 gap-8 mb-24"
        >
          {features.map((feature, index) => (
            <div key={index} className="border-l border-white/10 pl-6">
              <h3 className="text-lg font-medium text-white mb-2">{feature.title}</h3>
              <p className="text-sm text-white/50">{feature.desc}</p>
            </div>
          ))}
        </motion.div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-20 text-center"
        >
          <a 
            href="/case-studies"
            className="inline-flex items-center gap-2 text-sm text-white/50 hover:text-white transition-colors"
          >
            {isTurkish ? 'Temsili İş Akışı Senaryolarını Gör' : 'View Illustrative Workflow Scenarios'}
            <span>→</span>
          </a>
        </motion.div>

      </div>
    </section>
  );
}
